import React, { useEffect, useMemo, useState } from 'react';


// Determines if the ref is currently on the screen
export default function useOnScreen(ref: React.MutableRefObject<any>) {

    const [isIntersecting, setIntersecting] = useState(false);

    // useMemo to prevent re-creation on every render
    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting),
    ), []);

    useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }

        // Remove the observer as soon as the component is unmounted
        return () => { observer.disconnect(); };
    }, [ref.current]);

    return isIntersecting;
}